import type { Article, KickerId, PublicPlayer, Verdict } from '@gazette/shared';
import { t } from '../../i18n/index.ts';
import { Portrait } from './Portrait.tsx';

export function Headline({ kicker, headline }: { kicker: KickerId; headline: string }) {
  return (
    <>
      <span class="kicker">{t(`kicker.${kicker}`)}</span> — {headline}
    </>
  );
}

/** A newsprint clipping as the DOM shows it: the readable twin of the one pinned in 3D. */
export function Clipping({
  article,
  victim,
  verdict,
  author,
  size = 'large',
}: {
  article: Pick<Article, 'number' | 'kicker' | 'headline' | 'subtitle'>;
  victim?: PublicPlayer;
  verdict?: Verdict;
  author?: PublicPlayer;
  size?: 'large' | 'small';
}) {
  return (
    <article class={`clipping clipping--${size}`}>
      <p class="clipping__meta">
        <span>La Gazette</span>
        <span>{t('gz.edition', { n: article.number })}</span>
      </p>
      <h2 class="clipping__headline">
        <Headline kicker={article.kicker} headline={article.headline || '…'} />
      </h2>
      {article.subtitle && <p class="clipping__sub">{article.subtitle}</p>}
      {victim && (
        <p class="clipping__concerns">
          <Portrait seed={victim.portrait} width={size === 'large' ? 34 : 26} />
          {t('inv.concerns', { name: victim.name })}
        </p>
      )}
      {author && <p class="clipping__byline">{t('gz.signed', { name: author.name })}</p>}
      {verdict && <span class={`ink-stamp ink-stamp--${verdict.isTrue ? 'true' : 'false'}`}>{t(verdict.isTrue ? 'rev.true' : 'rev.false')}</span>}
    </article>
  );
}
